module.exports = __webpack_public_path__ + "img/gemini.eba6b1b7.png";